import { Button } from 'devextreme-react';
import './traceability.scss';
import DataGrid, { Toolbar, Item, SearchPanel, Column, Lookup, Paging, Button as ButtonGrid, LoadPanel } from 'devextreme-react/data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import { filter } from '../../images/icons';
import { ModalFilter } from './components/ModalFilter';
import { useFunctionsTrace } from './functions/functions';
import { useAppSelector } from '../../contexts/hooks';
import { CustomFilters, TypeTableFilter } from '../../types/types.system';
import { useApiTrace } from '../../api/api.trace';
import moment from 'moment';
import { SysI_MonitoreoOrdenes } from '../../types/types.monitoreo';
import { PopupInformation } from '../../components/utils/popup-information/PopupInformation';

const Index = ({ currentFilter }: { currentFilter?: CustomFilters[] }) => {
  const { getConfigurationTrace } = useFunctionsTrace();
  const { LstAccionesMonitoreo, LstUsuarios } = useAppSelector((x) => x.configuration);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { getData } = useApiTrace();
  const [gridFilters, setGridFilters] = useState<CustomFilters[]>(currentFilter ?? []);
  const [data, setData] = useState<any[]>([]);
  const gridRef = useRef<DataGrid>(null);
  const [selectedItem, setSelectedItem] = useState<SysI_MonitoreoOrdenes>();

  useEffect(() => {
    //Obtenemos la data de los filtros de monitoreo
    if (LstAccionesMonitoreo.length === 0 || LstUsuarios.length === 0) {
      getConfigurationTrace();
    }
  }, []);

  useEffect(() => {
    setFilter();
  }, [gridFilters]);

  const setFilter = useCallback(() => {
    try {
      gridRef.current?.instance.beginCustomLoading('');
      getData(gridFilters).then((res) => {
        setData(res);
      });
    } finally {
      gridRef.current?.instance.endCustomLoading();
    }
  }, [gridFilters]);

  const handleApplyFilter = useCallback(
    (data) => {
      console.log(data);
      const filterTest: CustomFilters[] = [];
      Object.keys(data).forEach((item) => {
        if (data[item]) {
          switch (item) {
            case 'Mto_Fecha':
              filterTest.push({ Value: moment(data[item][0]).format(), Value2: moment(data[item][1]).format(), Field: item, TypeFilter: TypeTableFilter.Between });
              break;
            default:
              filterTest.push({ Value: data[item], Field: item, TypeFilter: TypeTableFilter.Equal });
              break;
          }
        }
      });

      setGridFilters(filterTest);
      setModalVisible(false);
    },
    [setModalVisible, setGridFilters]
  );

  const handleRefresh = useCallback(() => {
    setFilter();
  }, []);

  const handleModalHideFilter = useCallback(() => {
    setModalVisible(false);
  }, [setModalVisible]);

  const handleModalShowFilter = useCallback(() => {
    setModalVisible(true);
  }, [setModalVisible]);

  const handlePreview = useCallback((e) => {
    const data: SysI_MonitoreoOrdenes = e.row.data;
    setSelectedItem(data);
  }, []);

  return (
    <div className={currentFilter ? '' : 'view crm-contact-list'}>
      <div className={currentFilter ? '' : 'view-wrapper view-wrapper-contact-list'}>
        <DataGrid height={'100%'} className='grid' ref={gridRef} dataSource={data} rowAlternationEnabled={true}>
          <LoadPanel enabled={true} />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={false} />
          <Toolbar>
            {!currentFilter && (
              <Item location='before'>
                <div className='grid-header'>Trazabilidad</div>
              </Item>
            )}
            {!currentFilter && (
              <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                <Button icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
              </Item>
            )}
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Button icon='refresh' text='Actualizar' stylingMode='text' onClick={handleRefresh} />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column name='Mto_Fecha_Fecha' dataField='Mto_Fecha' dataType='datetime' format={'yyyy/MM/dd'} caption='FECHA' />
          <Column name='Mto_Fecha_Hora' dataField='Mto_Fecha' dataType='datetime' format={'hh:mm aa'} caption='HORA' />
          {!(currentFilter && currentFilter.filter((x) => x.Field === 'Mto_Ord_Id').length > 0) && <Column dataField='Orden.Ord_Numero' caption='ORDEN' />}
          <Column dataField='Usuario.Us_Usuario' caption='USUARIO' />
          <Column dataField='Mto_Acm_Id' caption='OPERACIÓN'>
            <Lookup dataSource={LstAccionesMonitoreo} displayExpr={'Acm_Nombre'} valueExpr={'Acm_Id'} />
          </Column>
          <Column type='buttons' caption='DETALLE'>
            <ButtonGrid hint='Visualizar' icon='eyeopen' onClick={handlePreview} />
          </Column>
        </DataGrid>
  
        {selectedItem && (
          <PopupInformation visible={!!selectedItem} handleClose={() => setSelectedItem(undefined)} width={700} title='Detalle trazabilidad'>
            <div className='popup-information'>
              <div className='popup-information-content'>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Fecha:</div>
                  <div className='popup-information-content-row-value'>{moment(selectedItem.Mto_Fecha).format('DD/MM/YYYY HH:mm')}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Usuario:</div>
                  <div className='popup-information-content-row-value'>{selectedItem.Usuario.Us_Usuario}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Orden:</div>
                  <div className='popup-information-content-row-value'>{selectedItem.Orden.Ord_Numero}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Estudio:</div>
                  <div className='popup-information-content-row-value'>{selectedItem.Estudio?.Es_Nombre || 'N/A'}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Analito:</div>
                  <div className='popup-information-content-row-value'>{selectedItem.Analito?.An_Nombre || 'N/A'}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Operación:</div>
                  <div className='popup-information-content-row-value'>{LstAccionesMonitoreo.find((x) => x.Acm_Id === selectedItem.Mto_Acm_Id)?.Acm_Nombre || 'N/A'}</div>
                </div>
                <div className='popup-information-content-row'>
                  <div className='popup-information-content-row-title'>Observación:</div>
                  <div className='popup-information-content-row-value'>{selectedItem.Mto_Observacion}</div>
                </div>
              </div>
            </div>
          </PopupInformation>
        )}

        <ModalFilter visible={modalVisible} handleApplyFilter={handleApplyFilter} handleCancelFilter={handleModalHideFilter} />
      </div>
    </div>
  );
};

export default Index;
